import { jsx, jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { Accordion } from "../../../Accordion/Accordion.js";
import { AccordionSummary } from "../../../Accordion/AccordionSummary.js";
import { FontSizeInput } from "./components/FontSizeInput.js";
import { FontWeightInput } from "./components/FontWeightInput.js";
import { LetterSpacingInput } from "./components/LetterSpacingInput.js";
import { LineHeightInput } from "./components/LineHeightInput.js";
import { ResetButton } from "./components/ResetButton.js";
import { Row } from "./components/Row.js";
import { useTypographyVariant } from "./hooks/useTypographyVariant.js";
function TypographyVariant(props) {
  const { section, expanded, onExpand } = props;
  const { fontSize, fontWeight, lineHeight, letterSpacing, all, htmlFontSize } = useTypographyVariant(section);
  const handleOnExpand = useCallback(
    (_, newExpanded) => {
      onExpand?.(section, newExpanded);
    },
    [onExpand, section]
  );
  return /* @__PURE__ */ jsxs(Accordion, { expanded, onChange: handleOnExpand, children: [
    /* @__PURE__ */ jsxs(AccordionSummary, { "aria-controls": `panel${section}-content`, id: `panel${section}-header`, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", children: section }),
      /* @__PURE__ */ jsx(Row, { pl: 1.5, children: /* @__PURE__ */ jsx(ResetButton, { disabled: all.disabled, onClick: all.onReset, children: "reset" }) })
    ] }),
    /* @__PURE__ */ jsxs(Stack, { gap: 0.75, p: 2, children: [
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(
          FontSizeInput,
          {
            htmlFontSize,
            onChange: fontSize.onChange,
            title: "Font size",
            value: fontSize.value
          }
        ),
        /* @__PURE__ */ jsx(ResetButton, { disabled: fontSize.disabled, onClick: fontSize.onReset, size: "small", sx: { ml: 1 }, children: "reset" })
      ] }),
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(LineHeightInput, { onChange: lineHeight.onChange, title: "Line Height", value: lineHeight.value }),
        /* @__PURE__ */ jsx(ResetButton, { disabled: lineHeight.disabled, onClick: lineHeight.onReset, children: "reset" })
      ] }),
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(
          LetterSpacingInput,
          {
            fontSizePixel: fontSize.pxValue,
            onChange: letterSpacing.onChange,
            title: "Letter spacing",
            value: letterSpacing.value
          }
        ),
        /* @__PURE__ */ jsx(ResetButton, { disabled: letterSpacing.disabled, onClick: letterSpacing.onReset, children: "reset" })
      ] }),
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(
          FontWeightInput,
          {
            onChange: fontWeight.onChange,
            options: [300, 400, 500, 700],
            title: "Font weight",
            value: fontWeight.value
          }
        ),
        /* @__PURE__ */ jsx(ResetButton, { disabled: fontWeight.disabled, onClick: fontWeight.onReset, children: "reset" })
      ] })
    ] })
  ] });
}
export {
  TypographyVariant
};
//# sourceMappingURL=TypographyVariant.js.map
